import { FaInfoCircle } from "react-icons/fa";

export const AutocompleteInfoBanner = () => {
  return (
    <div className="flex items-start gap-2 bg-blue-50 border-l-4 border-blue-400 p-3 rounded-md text-sm text-gray-800 mt-2 w-full">
      <FaInfoCircle className="mt-0.5 text-blue-500 flex-shrink-0" />
      <div>
        Google addresses are not always 100% accurate. Please verify the
        street, postal code, and suite/unit, especially for business addresses to avoid adjustment charges later.
      </div>
    </div>
  );
};